import { defineAttrs as r } from "../../utils/typed-attrs.js";
const n = r({
  uri: { default: "" },
  name: { default: "" }
}), i = {
  inline: !0,
  attrs: n,
  group: "inline",
  selectable: !0,
  parseDOM: [
    {
      tag: "span.embercom-prosemirror-composer-mention",
      getAttrs(t) {
        return {
          name: t.innerText,
          uri: t.getAttribute("data-uri")
        };
      }
    }
  ],
  toDOM(t) {
    const e = t.attrs;
    return [
      "span",
      { class: "embercom-prosemirror-composer-mention", "data-uri": e.uri },
      e.name
    ];
  }
};
export {
  i as mentionSpec
};
